import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Zap } from "lucide-react";
import api from "@/lib/api";

export default function SalesTicker() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const load = () => api.get("/activity/recent").then((r) => setItems(r.data)).catch(() => {});
    load();
    const refresh = setInterval(load, 60000);
    return () => clearInterval(refresh);
  }, []);

  useEffect(() => {
    if (!items.length) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % items.length), 4500);
    return () => clearInterval(id);
  }, [items.length]);

  if (!items.length) return null;
  const it = items[idx % items.length];
  const ago = it.minutes_ago < 60 ? `${it.minutes_ago}M AGO` : `${Math.floor(it.minutes_ago / 60)}H AGO`;

  return (
    <div className="fixed bottom-4 left-4 z-40 pointer-events-none" data-testid="sales-ticker">
      <AnimatePresence mode="wait">
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.35 }}
          className="flex items-center gap-3 border border-white/15 bg-black/85 backdrop-blur-md px-4 py-2.5"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full bg-white/60" />
            <span className="relative inline-flex h-2 w-2 bg-white" />
          </span>
          <span className="font-mono text-[10px] tracking-[0.12em] text-white/70">
            <span className="text-white">{it.tag}</span> grabbed <span className="text-white">{it.product}</span>
            {it.tier ? ` // ${it.tier}` : ""} <span className="text-white/35">· {ago}</span>
          </span>
          <Zap size={11} className="text-white/40" />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
